/**
---
name: GoogleMaps
description: Standard Google Map direction widget using V3 API.
authors:
- David Chan CK (http://www.reol.com)
license:
- MIT-style license
requires:
- core/1.2.4: '*'
- more/1.2.4.4: [Utilities.Assets]
- LazyLoader
- Remote
provides: [GoogleMaps]
...
*/

/**
Core Map
=========
This is the base class for abstracting Google Maps JavaScript API.

Options
-------
+ _cls_ : The CSS class name for the widget
+ rpc : The data that gets loaded
+ api : Path to the Google Maps API
+ ext_path : To load in external components
**/

var GoogleMaps = new Class
({
	Extends: DisplayObject,
	Implements: [Options, Events],
	options:
	{
		cls: 'w_googlemaps',
		rpc: null,
		ext_path: '',
		callbacks: {},
		dependency_loaded: false, // true if all dependecies are already part of page.js
		dependencies: [
			'GoogleMaps.Bubble',
			'GoogleMaps.BubbleExt',
			'GoogleMaps.Control',
			'GoogleMaps.Control.Type',
			'GoogleMaps.Control.Zoom',
			'GoogleMaps.Marker',
			'GoogleMaps.Overlay',
			'GoogleMaps.OverlayExt'
		],

		styled: true,
		zoomControl: true,
		fullscreenControl: false,
		mapTypeControl: true, 
		map_styles: [
			{
				"featureType": "road.arterial",
				"stylers": [
					{ "color": "#e4e4e4" }
				]
			},{
				"featureType": "road.arterial",
				"elementType": "geometry.stroke",
				"stylers": [
					{ "color": "#808080" }
				]
			},{
				"featureType": "landscape",
				"stylers": [
					{ "color": "#f6f3f0" }
				]
			},{
				"featureType": "water",
				"stylers": [
					{ "color": "#b3c2d0" }
				]
			},{
				"featureType": "road.highway",
				"stylers": [
					{ "color": "#b4b4b4" }
				]
			},{
				"featureType": "poi",
				"stylers": [
					{ "color": "#cddbc9" }
				]
			},{
				"featureType": "road.arterial",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "poi",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "poi.government",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "landscape",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "road",
				"elementType": "geometry.stroke",
				"stylers": [
					{ "color": "#a5a5a5" }
				]
			},{
				"featureType": "landscape",
				"elementType": "geometry.stroke",
				"stylers": [
					{ "color": "#dadbda" }
				]
			},{
				"featureType": "transit",
				"elementType": "labels.icon",
				"stylers": [
					{ "saturation": 100 }
				]
			},{
				"featureType": "poi.park"
			},{
				"featureType": "poi",
				"elementType": "labels",
				"stylers": [
					{ "visibility": "off" }
				]
			}
		]
	},
/**

initialize
----------
Checks for the existence of required elements

###Arguments
+ _element_: The element which will hold this widget
+ _options_: Pass in a hash of options for the class

**/
	initialize: function(element, instance_name, options)
	{
		this._element = $(element);
		//this.instance_name = [instance_name, false].pick();
		// no longer need "instance_name"
		if(typeOf(instance_name) == 'string'){
			Log.log('GoogleMaps no longer need the paramenter "instance_name".');
		}
		if(arguments.length == 2){
			 options = instance_name;
		}

		if ($(this) != null){
			this.setOptions(options);
			this.options.rpc = this.options.rpc || this._element.get('data-rpc');
			this.fireEvent('initialize', this)
					.parent();
			return;
		}else{
			//Log.log('Google Maps expects two parameters');
		}
	},
/**

build
----------
Sets up default attributes and load dependencies

###Arguments
+ _none_

**/
	build: function()
	{
		this.parent();
		var opts = this.options;
		this.loader;
		this.markers = [];
		this._map	= $(this).getElement('.'+opts.cls+'_map');
		this.fireEvent('build', this);

		if(!opts.dependency_loaded){
			this.load_dependencies();
		}
		else{
			var loaded = false;
			var lazyloadOffset = 500;

			if (!this.options.add_lazy_load || !loaded && this._map.getPosition().y !== 0 && this._map.getPosition().y < window.getScroll().y + window.innerHeight + lazyloadOffset) {
				this.run_rpc();
				loaded = true;
			}

			window.addEvent('scroll', function(){
				if (!loaded && this.options.add_lazy_load && this._map.getPosition().y !== 0 && this._map.getPosition().y < window.getScroll().y + window.innerHeight + lazyloadOffset) {
					this.run_rpc();
					loaded = true;
				}
			}.bind(this));
		}
	},

/**

defer_build
----------
Runs once dependencies have been loaded.

###Arguments
+ _none_

**/
	defer_build: function()
	{
		this.map = new google.maps.Map(this._map,
		{
			 zoom: 10,
			 center: new google.maps.LatLng(40.7630980, -73.9622850),
			 mapTypeId: google.maps.MapTypeId.ROADMAP,
			 streetViewControl: false,
			 scrollwheel: false,
			 zoomControl: this.options.zoomControl,
			 fullscreenControl:  this.options.fullscreenControl,
			 mapTypeControl: this.options.mapTypeControl
		});

		if(this.options.styled){
			this.map.setOptions({styles: this.options.map_styles});
		}

		// call rpc after loading the dependencies
		if(!this.options.dependency_loaded){
			if(this.options.rpc){
				this.main_remote = new Remote
				({
					rpc: this.options.rpc,
					rpc_path: '',
					onSuccess: this.process_rpc.bind(this)
				});
			}
		}
		else{
			this.process_rpc();
		}
	},

	run_rpc: function(){
		if(this.options.rpc){
			this.main_remote = new Remote
			({
				rpc: this.options.rpc,
				rpc_path: '',
				method: 'get',
				onSuccess: this.load_map_api.bind(this)
			});
		}
	},
/**

bound_overlays
----------
Calls fitBounds which takes all overlay elements and resize the viewport to see all elements.

###Arguments
+ _none_

**/
	bound_overlays: function()
	{
		var bounds = new google.maps.LatLngBounds();

		this.markers.each(function(marker)
		{
			bounds.extend(marker.get_object().getPosition());
		});

		this.map.fitBounds(bounds);
		this.map.setCenter(bounds.getCenter());
		this.fireEvent('boundOverlays', this);
	},
/**

destroy_markers
----------
Removes all markers from the map.

###Arguments
+ _offset_from_index_ : offset for exception, useful when first item is permanent.

**/
	destroy_markers: function(offset_from_index)
	{
		console.log('destroy markers');
		var cache = [];
				offset_from_index = [offset_from_index, 0].pick();

		this.markers.each(function(marker, i)
		{
			if (i < offset_from_index)
			{
				cache.push(marker);
			}
			else
			{
				// marker.get_object().setMap(null);
				// delete marker;
			}
		});
		this.markers = cache;
	},

/**

init_dependencies
----------
Call methods to load specific dependencies.

###Arguments
+ _none_

**/
	init_dependencies: function()
	{
		this.fireEvent('initDependencies', this);
		this.load_map_api();
	},

/**

load_dependencies
----------
Load external component via LazyLoader.

###Arguments
+ _none_

**/
	load_dependencies: function()
	{
		var opts = this.options;

		this.loader = new LazyLoader.Multiple((opts.dependencies || this.get_dependencies()), {
			path: opts.ext_path
		});

		this.loader.addEvent('load', this.init_dependencies.bind(this));
		return;
	},

/**

load_map_api
----------
Load Google Maps JS API remotely.

###Arguments
+ _none_

**/
	load_map_api: function()
	{
		// var opts = this.options;

		// this.u_cb_id = 'map_onload_callback_'+((((1+Math.random())*0x10000)|0).toString(16));
		// window[this.u_cb_id] = function(){
		//	 this.defer_build();
		// }.bind(this);

		// new Asset.javascript(opts.api+'&callback='+this.u_cb_id+'&other_params=client');
		Core.load_google_api(this.defer_build.bind(this));
		// return this.fireEvent('mapAPILoad', this);
	},
/**

process_rpc
----------
Action to take when rpc is loaded.

###Arguments
+ _none_

**/
	process_rpc: function()
	{
		//Log.log(this.main_remote);
		var data = this.main_remote.get_data().ini;
		this.map.setCenter(new google.maps.LatLng(data.lat, data.lng));
		this.fireEvent('processRPC', this);
	},
/**

get_dependencies
----------
Method to override to add in all necessary external components.

###Arguments
+ _none_

**/
	get_dependencies: function()
	{
		Log.log('GoogleMaps.get_dependencies is deprecated. Please use options.dependencies');
		return [
			'GoogleMaps.Bubble',
			'GoogleMaps.Control',
			'GoogleMaps.Control.Type',
			'GoogleMaps.Control.Zoom',
			'GoogleMaps.Marker',
			'GoogleMaps.Overlay'
		];
	},
/**

get_rpc_path
----------
Returns the path to the rpc. (deprecated)

###Arguments
+ _none_

**/
	get_rpc_path: function()
	{
		return this.options.rpc_path;
	}
});

/**
Example Usage
-------------
		var global_map;

		// instance variable must be globally scoped
		global_map = new GoogleMaps($('maps'), 'global_map',
		{
				rpc: 'googlemaps.json',
				ext_path: '/internal/widget/GoogleMaps/Source/External/{Klass}.js'
		});
*/
